import { StoredRegistrationData } from "../types/storedRegistrationData";

const LOCAL_STORAGE_KEY = "registrationData";

const getRegistrationData = (): StoredRegistrationData => {
  const data = localStorage.getItem(LOCAL_STORAGE_KEY);
  const parsedData: StoredRegistrationData = JSON.parse(data || "{}");

  return parsedData;
};

const saveRegistrationData = (data: Partial<StoredRegistrationData>) => {
  const storedData = getRegistrationData();
  const newData: StoredRegistrationData = { ...storedData, ...data };

  localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(newData));

  return newData;
};

const deleteRegistrationData = () => {
  localStorage.removeItem(LOCAL_STORAGE_KEY);
};

export { getRegistrationData, saveRegistrationData, deleteRegistrationData };
